import { COLUMNS_DISTRIBUCION_POR_CEREAL, COLUMNS_DISTRIBUCION_POR_CEREAL_TO_PRINT } from './constantesDistribucionPorCereal'
import { TABLE_DISTRIBUCION_POR_CEREAL } from '../../../../../config/tables'
import { TablaDistribucionPorCerealService } from '../../../../../models/movimiento/cuadroDeMando/tabla_distribucion_por_cereales'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import React from 'react'
import { Button } from 'react-bootstrap'

export function actualizarDatosParaMuiTable (conLink) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLE_DISTRIBUCION_POR_CEREAL
    })
    const promiseTablaDistribucionPorCereal = TablaDistribucionPorCerealService.getDataTablaDistribucionPorCereal()
    const promiseTablaDistribucionPorCerealTotal = TablaDistribucionPorCerealService.getDataTablaDistribucionPorCerealTotal()
    Promise.all([promiseTablaDistribucionPorCereal, promiseTablaDistribucionPorCerealTotal]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = () => <> {pdfCustomToolbarGenerator(
        'Distribución Por Cereal',
        dataCombinada,
        COLUMNS_DISTRIBUCION_POR_CEREAL_TO_PRINT,
        'portrait')()}{conLink && <Button href='/laridae/movimiento/distribucionPorCereal' class='btn btn-primary btn-lg active' role='button' aria-pressed='true'>Detalles Por Cereal</Button>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DISTRIBUCION_POR_CEREAL,
          data: dataCombinada,
          title: `Distribución Por Cereal`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }

        },
        id: TABLE_DISTRIBUCION_POR_CEREAL
      })
    }
  }
}
